module.exports = __webpack_public_path__ + "static/background-faaf3c571ad5b0171b67a8f0487aa243.png";